export var ConnectivityStatus;
(function (ConnectivityStatus) {
    ConnectivityStatus[ConnectivityStatus["NotReporting"] = 0] = "NotReporting";
    ConnectivityStatus[ConnectivityStatus["PartiallyConnected"] = 1] = "PartiallyConnected";
    ConnectivityStatus[ConnectivityStatus["Connected"] = 2] = "Connected";
})(ConnectivityStatus || (ConnectivityStatus = {}));
